import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";

export class DailyRewardReporter extends Phaser.Group {

    private reporterSprite: Phaser.Sprite;
    private reporterIdleTween: Phaser.Tween;
    private reporterWinTween: Phaser.Tween;
    private balloonSprite: Phaser.Sprite;
    private gameText: any;
    private shakeReporter: boolean;

    constructor(game: Phaser.Game) {

        super(game, null, "daily-reward-reporter", false);

        this.shakeReporter = false;

        this.reporterIdleTween = null;
        this.reporterWinTween = null;

        this.reporterSprite = this.create(-250, 1010, "texture_atlas_6", "speaker_idle");
        this.reporterSprite.anchor.setTo(0, 1);
        this.reporterSprite.scale.y = GameVars.scaleY;
        this.reporterSprite.angle = -15;

        this.balloonSprite = this.create(210, 800, "texture_atlas_6", "balloon");
        this.balloonSprite.scale.y = GameVars.scaleY;
        this.balloonSprite.visible = false;

        this.gameText = GameVars.gameText;
    }

    public update(): void {

        super.update();

        if (this.shakeReporter) {

            if (Math.random() > .5) {
                this.reporterSprite.x = Math.random() * 3;
                this.reporterSprite.y = 1010 + Math.random() * 3;
            }
        }
    }

    public destroy(destroyChildren?: boolean, soft?: boolean): void {

        super.destroy(destroyChildren, soft);

        if (this.reporterIdleTween !== null) {
            this.reporterIdleTween.pendingDelete = true;
        }

        if (this.reporterWinTween !== null) {
            this.reporterWinTween.pendingDelete = true;
        }
    }

    public appear(): void {

        this.game.add.tween(this.reporterSprite).
            to({ x: 10, angle: 0 }, 500, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function (): void {

                this.reporterIdleTween = this.game.add.tween(this.reporterSprite.scale);
                this.reporterIdleTween.to({ x: 1.02, y: .95 * GameVars.scaleY }, 300, Phaser.Easing.Linear.None, false);
                this.reporterIdleTween.delay(1200);
                this.reporterIdleTween.to({ x: .98, y: 1.05 * GameVars.scaleY }, 700, Phaser.Easing.Elastic.Out);
                this.reporterIdleTween.loop();
                this.reporterIdleTween.start();

            }, this);
    }

    public onCreditsWon(credits: number): void {

        this.reporterIdleTween.pendingDelete = true;

        this.reporterSprite.frameName = "speaker_reward";
        this.balloonSprite.visible = true;

        const creditsLabel = new Phaser.Text(this.game, 35, 24,
            credits.toString() + " " + this.gameText.REWARD_COINS, { font: "34px Ubuntu", fontWeight: "700", fill: "#000000", align: "center" });
        this.balloonSprite.addChild(creditsLabel);

        this.activateWinTween();
    }

    public onNothingWon(): void {

        this.shakeReporter = true;

        this.reporterIdleTween.pendingDelete = true;

        this.reporterSprite.frameName = "speaker_fail";
        this.balloonSprite.visible = true;

        const nothingLabel = new Phaser.Text(this.game, 35, 24,
            this.gameText.REWARD_NOTHING, { font: "32px Ubuntu", fontWeight: "700", fill: "#000000", align: "center" });
        this.balloonSprite.addChild(nothingLabel);
    }

    public onPowerUpWon(powerUpType: string): void {

        this.reporterIdleTween.pendingDelete = true;

        this.reporterSprite.frameName = "speaker_reward";
        this.balloonSprite.visible = true;

        var messageStr: string;
        var font: string;

        switch (powerUpType) {
            case GameConstants.FREEZE_GOALKEEPER_REWARD:
                messageStr = this.gameText.REWARD_FREEZE_GOALKEEPER;
                font = "25px Ubuntu";
                break;
            case GameConstants.THREE_EXTRA_BALLS_REWARD:
                messageStr = this.gameText.REWARD_THREE_BALLS;
                font = "24px Ubuntu";
                break;
            case GameConstants.BALL_OF_FIRE_REWARD:
                messageStr = this.gameText.REWARD_BALL_OF_FIRE;
                font = "28px Ubuntu";
                break;
            case GameConstants.VOODOO_REWARD:
                messageStr = this.gameText.REWARD_VODOO;
                font = "21px Ubuntu";
                break;
            default:
        }

        const powerUpLabel = new Phaser.Text(this.game, 20, 32,
            messageStr, { font: font, fontWeight: "700", fill: "#000000", align: "center" });
        this.balloonSprite.addChild(powerUpLabel);

        this.activateWinTween();
    }

    private activateWinTween(): void {

        this.reporterWinTween = this.game.add.tween(this.reporterSprite);
        this.reporterWinTween.to({ y: 1018 }, 150, Phaser.Easing.Cubic.Out, true, 0, -1, true);
    }
}
